// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"DefaultNavFooter_aboutContainer__3IiGi","separator":"DefaultNavFooter_separator__2py_7"};